import React, { useState } from 'react';
import { Box, Typography, Paper, Alert, Button, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, TextField } from '@mui/material';
import LivenessCheck from '../../components/LivenessCheck';
import CameraEnhanceIcon from '@mui/icons-material/CameraEnhance';
import { CombinedResult, ValidationType } from '../../services/livenessService';

const LivenessValidation = () => {
  const [result, setResult] = useState<CombinedResult | null>(null);
  const [isStarted, setIsStarted] = useState(false);
  const [validationType, setValidationType] = useState<ValidationType>('LIVENESS');
  const [userId, setUserId] = useState<number | undefined>();

  const handleComplete = (result: CombinedResult) => {
    setResult(result);
    setIsStarted(false);
  };

  const handleError = (errorMessage: string) => {
    setIsStarted(false); // Reset em caso de erro
  };

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Validação de Vida
      </Typography>

      <Paper sx={{ p: 3, mt: 3 }}>
        {!isStarted ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <FormControl>
              <FormLabel>Tipo de Validação</FormLabel>
              <RadioGroup
                value={validationType}
                onChange={(e) => setValidationType(e.target.value as ValidationType)}
              >
                <FormControlLabel value="LIVENESS" control={<Radio />} label="Apenas Liveness" />
                <FormControlLabel value="VERIFY" control={<Radio />} label="Verificar com Usuário (1:1)" />
                <FormControlLabel value="SEARCH" control={<Radio />} label="Buscar Usuário (1:N)" />
              </RadioGroup>
            </FormControl>

            {validationType === 'VERIFY' && (
              <TextField
                label="ID do Usuário"
                type="number"
                value={userId || ''}
                onChange={(e) => setUserId(Number(e.target.value))}
                required
              />
            )}

            <Button
              variant="contained"
              startIcon={<CameraEnhanceIcon />}
              onClick={() => setIsStarted(true)}
              size="large"
              disabled={validationType === 'VERIFY' && !userId}
            >
              Iniciar Validação
            </Button>
          </Box>
        ) : (
          <LivenessCheck
            type={validationType}
            userId={userId}
            onComplete={handleComplete}
            onError={handleError}
          />
        )}

        {result && (
          <Alert 
            severity={result.liveness.status === 'SUCCEEDED' ? "success" : "error"}
            sx={{ mt: 3 }}
          >
            <Typography>
              Liveness: {result.liveness.status === 'SUCCEEDED' 
                ? `Sucesso (Confiança: ${result.liveness.confidence.toFixed(2)}%)`
                : 'Falha'}
            </Typography>
            {result.verify && (
              <Typography>
                Verificação 1:1: {result.verify.is_match 
                  ? `Match encontrado (Score: ${result.verify.score.toFixed(2)})` 
                  : 'Nenhum match encontrado'}
              </Typography>
            )}
            {result.search && (
              <Typography>
                Busca 1:N: {result.search.is_match 
                  ? `Match encontrado (Score: ${result.search.score.toFixed(2)})` 
                  : 'Nenhum match encontrado'}
                {result.search.user_id && ` - ID do usuário: ${result.search.user_id}`}
              </Typography>
            )}
          </Alert>
        )}
      </Paper>
    </Box>
  );
};

export default LivenessValidation; 